import { gql } from "@apollo/client";

const REFRESH_TOKEN = gql`
  mutation refreshToken($refreshToken: String!) {
    response: refresh_token(refresh_token: $refreshToken) {
      id
      name
      access_token
      id_token
      refresh_token
      fmcg_cookie
      fmcg_token
      fmcg_account_id
    }
  }
`;

export { REFRESH_TOKEN };
